var data = [
  {
    id: 0,
    title: "Introducción al diseño",
    description:
      "El diseño lo es todo. Descubre los conceptos esenciales para empezar a comunicar tus ideas a través de composiciones gráficas.",
    image: "https://i.imgur.com/4VkW8FW.png",
    imageHR: "https://i.imgur.com/jywVD4h.png",
    imageAlt: "Logo introducción al diseño",
    backgroundStyle: { backgroundColor: "#B7B6B6" },
    textColor: { color: "#000" },
    duration: "90",
    courseRoute: "/cursos/introduccion-diseño",
    numUnits: 4,
    numSubjects: 14,
    frame:
      '<iframe width="100%" height="100%" src="https://iseazy.com/dl/cca49c1e32c44e95acb0dcde608902eb" frameborder="0" allowfullscreen/>',
    linkForm:
      "https://forms.office.com/Pages/ResponsePage.aspx?id=DQSIkWdsW0yxEjajBLZtrQAAAAAAAAAAAAZ__rCZHlhUNjY3NkxRMzFBMDNIOE9SOEtYSDFLTURSQi4u",
    linkReport:
      "https://forms.office.com/Pages/ResponsePage.aspx?id=DQSIkWdsW0yxEjajBLZtrQAAAAAAAAAAAAZ__rCZHlhUN0lMMEtUSk9EUlJZWlcwTlJQWVU5MFA5Ty4u",
    linkDownload:
      "https://drive.google.com/drive/folders/1fL4pPPesnmBQBVqCrehVpJfeCF0xhroM?usp=sharing",
    linkFrame: "https://iseazy.com/dl/cca49c1e32c44e95acb0dcde608902eb",
    upNext: 1,
    metadata: {
      general: {
        title: "Introducción al diseño",
        language: "Español",
        description: "El contenido del recurso describe los conceptos fundamentales para entender el proceso de diseño, a través del uso de piezas reales basadas en distintos contextos.",
        keywords: "Diseño, Design Thinking, Composición, Tipografía, Elementos visuales.",
      },
      lifecycle: {
        version: "1.0",
        author: "Javier Andrés Collazos Gómez",
        entity: "Universidad de Ibagué, Nido",
        date: "09/02/2021",
      },
      technical: {
        format: "iFrame, .zip",
        size: "135",
        location:
          "https://javiermojito.github.io/nido/#/cursos/introduccion-diseño",
        requirement: `- Tipo: Navegador 
                      - Nombre: Cualquiera`,
        instructions: `Online: acceder a la ruta desde un navegador web.

        Offline: Descomprimir el archivo .zip con su software de preferencia. Ejecutar el archivo con el nombre y simbolo del recurso.`
      },
      educational: {
        interactivityType: "Activo",
        learningResourceType: "Diapositiva",
        interactivityLevel: "Medio",
        targetPopulation: "Aprendiz",
        context: "Educación Secundaria, Educación Superior"
      },
      rights:{
        cost: "No",
        copyright: "Se permite su distribución libre y se prohíbe su uso comercial.",
        otherRestrictions: "Este recurso utiliza material de terceros como objetos de estudio."
      },
      annotation: {
        educationalUse: "Este recurso puede ser utilizado por docentes, estudiantes y cualquier usuario interesado en diseño. Sirve de material complementario para cursos relacionados al desarrollo de aplicaciones y la ingeniería de software.",
      },
      classification:{
        source: `Disciplina:
        - Diseño
        - Ingeniería de software`,
        taxonPath: "TBD"
      }
    },
  },
  {
    id: 1,
    title: "Teoría del color",
    description:
      "El color es un elemento visual fundamental para el diseño, incluso, es capaz de generar distintas emociones. Aprende a seleccionarlo, combinarlo y utilizarlo gracias a la teoría del color!",
    image: "https://i.imgur.com/J4dXVjY.png",
    imageHR: "https://i.imgur.com/CXbaTua.png",
    imageAlt: "Logo Teoría de color",
    backgroundStyle: { backgroundColor: "#222222" },
    textColor: { color: "#FFF" },
    duration: "90",
    courseRoute: "/cursos/teoria-color",
    numUnits: 4,
    numSubjects: 10,
    frame:
      '<iframe width="100%" height="100%" src="https://iseazy.com/dl/e776e4804362430a9b08f925ec70bc67" frameborder="0" allowfullscreen/>',
    linkForm:
      "https://forms.office.com/Pages/ResponsePage.aspx?id=DQSIkWdsW0yxEjajBLZtrQAAAAAAAAAAAAZ__rCZHlhUNjY3NkxRMzFBMDNIOE9SOEtYSDFLTURSQi4u",
    linkReport:
      "https://forms.office.com/Pages/ResponsePage.aspx?id=DQSIkWdsW0yxEjajBLZtrQAAAAAAAAAAAAZ__rCZHlhUN0lMMEtUSk9EUlJZWlcwTlJQWVU5MFA5Ty4u",
    linkDownload:
      "https://drive.google.com/drive/folders/1XtEfj2tWTVBhmb3FPTE60hz_3AddhmK4?usp=sharing",
    linkFrame: "https://iseazy.com/dl/e776e4804362430a9b08f925ec70bc67",
    upNext: 2,
    metadata: {
      general: {
        title: "Teoría del color",
        language: "Español",
        description: "El contenido del recurso describe los conceptos para comprender el origen del color y todo lo relacionado a la teoría del mismo. Hace uso de piezas de artistas como ejemplos de las distintas maneras de aplicar el color en una composición.",
        keywords: "Teoría del color, diseño, color, paletas de colores, armonía cromática, psicología del color, sistemas de colores.",
      },
      lifecycle: {
        version: "1.0",
        author: "Javier Andrés Collazos Gómez",
        entity: "Universidad de Ibagué",
        date: "11/02/2021",
      },
      technical: {
        format: "iFrame, .zip",
        size: "160",
        location: "https://javiermojito.github.io/nido/#/cursos/teoria-color",
        requirement: `- Tipo: Navegador 
                      - Nombre: Cualquiera`,
        instructions: `Online: acceder a la ruta desde un navegador web.

        Offline: Descomprimir el archivo .zip con su software de preferencia. Ejecutar el archivo con el nombre y simbolo del recurso.`
      },
      educational: {
        interactivityType: "Activo",
        learningResourceType: "Diapositiva",
        interactivityLevel: "Medio",
        targetPopulation: "Aprendiz",
        context: "Educación Secundaria, Educación Superior"
      },
      rights:{
        cost: "No",
        copyright: "Se permite su distribución libre y se prohíbe su uso comercial.",
        otherRestrictions: "Este recurso utiliza material de terceros como objetos de estudio."
      },
      annotation: {
        educationalUse: "Este recurso puede ser utilizado por docentes, estudiantes y cualquier usuario interesado en la teoría y manejo del color. Sirve de material complementario para cursos relacionados al desarrollo de aplicaciones y la ingeniería de software.",
      },
      classification:{
        source: `Disciplina:
        - Diseño
        - Ingeniería de software`,
        taxonPath: "TBD"
      }
    },
  },
  {
    id: 2,
    title: "Fundamentos UX",
    description:
      "El éxito de producto digital depende de la experiencia que sienta quien lo utiliza. Con este curso, aprenderás los conceptos esenciales relacionados con los principios de usabilidad, el User Research, la arquitectura de información y el prototipado con Wireframes.",
    image: "https://i.imgur.com/6BhOe0c.png",
    imageHR: "https://i.imgur.com/ZEE7h01.png",
    imageAlt: "Logo Diseño UX",
    backgroundStyle: { backgroundColor: "#342343" },
    textColor: { color: "#FFF" },
    duration: "100",
    courseRoute: "/cursos/fundamentos-ux",
    numUnits: 4,
    numSubjects: 11,
    frame:
      '<iframe width="100%" height="100%" src="https://iseazy.com/dl/325b1f9eea684999b87dc255c8383d87" frameborder="0" allowfullscreen/>',
    linkForm:
      "https://forms.office.com/Pages/ResponsePage.aspx?id=DQSIkWdsW0yxEjajBLZtrQAAAAAAAAAAAAZ__rCZHlhUNjY3NkxRMzFBMDNIOE9SOEtYSDFLTURSQi4u",
    linkReport:
      "https://forms.office.com/Pages/ResponsePage.aspx?id=DQSIkWdsW0yxEjajBLZtrQAAAAAAAAAAAAZ__rCZHlhUN0lMMEtUSk9EUlJZWlcwTlJQWVU5MFA5Ty4u",
    linkDownload:
      "https://drive.google.com/drive/folders/14-g4AqvuYmCQQPFoCksEB4WOisiAjF6-?usp=sharing",
    linkFrame: "https://iseazy.com/dl/325b1f9eea684999b87dc255c8383d87",
    upNext: 3,
    metadata: {
      general: {
        title: "Diseño UX",
        language: "Español",
        description: "El contenido del recurso desarrolla las etapas del proceso de diseño UX para formulación de un producto digital, basados en una idea. Describe en detalle la investigación por User Research con variedad de técnicas, y el proceso de arquitectura de información y prototipado de un producto con wireframes. ",
        keywords: "User Experiencie, Experiencia de usuario, User Research, Wireframes, Prototipos, investigación, diseño, diseño UX",
      },
      lifecycle: {
        version: "1.0",
        author: "Javier Andrés Collazos Gómez",
        entity: "Universidad de Ibagué",
        date: "09/09/09",
      },
      technical: {
        format: "iFrame, .zip",
        size: "218",
        location: "https://javiermojito.github.io/nido/#/cursos/diseno-ui",
        requirement: `- Tipo: Navegador 
                      - Nombre: Cualquiera`,
        instructions: `Online: acceder a la ruta desde un navegador web.

        Offline: Descomprimir el archivo .zip con su software de preferencia. Ejecutar el archivo con el nombre y simbolo del recurso.`
      },
      rights:{
        cost: "No",
        copyright: "Se permite su distribución libre y se prohíbe su uso comercial.",
        otherRestrictions: "Este recurso utiliza material de terceros como objetos de estudio."
      },
      educational: {
        interactivityType: "Activo",
        learningResourceType: "Diapositiva",
        interactivityLevel: "Medio",
        targetPopulation: "Aprendiz",
        context: "Educación Secundaria, Educación Superior"
      },
      annotation: {
        educationalUse: "Este recurso puede ser utilizado por docentes, estudiantes y cualquier usuario interesado en el diseño de experiencia de usuario. Sirve de material complementario para cursos relacionados al desarrollo de aplicaciones y la ingeniería de software.",
      },
      classification:{
        source: `Disciplina:
        - Diseño
        - Ingeniería de software`,
        taxonPath: "TBD"
      }
    },
  },
  {
    id: 3,
    title: "Diseño UI/UX",
    description:
      "Aprende a diseñar interfaces adaptables, define su arquitectura y sigue las mejores prácticas de este campo del diseño.",
    image: "https://i.imgur.com/DZihR3o.png",
    imageHR: "https://i.imgur.com/ypQQWEY.png",
    imageAlt: "Logo Diseño UI/UX",
    backgroundStyle: { backgroundColor: "#4E410E" },
    textColor: { color: "#FFF" },
    duration: "90",
    courseRoute: "/cursos/diseno-uiux",
    numUnits: 4,
    numSubjects: 12,
    frame:
      '<iframe width="100%" height="100%" src="https://iseazy.com/dl/edc605889bef4c9fbf671da6290ed9d3" frameborder="0" allowfullscreen/>',
    linkForm:
      "https://forms.office.com/Pages/ResponsePage.aspx?id=DQSIkWdsW0yxEjajBLZtrQAAAAAAAAAAAAZ__rCZHlhUNjY3NkxRMzFBMDNIOE9SOEtYSDFLTURSQi4u",
    linkReport:
      "https://forms.office.com/Pages/ResponsePage.aspx?id=DQSIkWdsW0yxEjajBLZtrQAAAAAAAAAAAAZ__rCZHlhUN0lMMEtUSk9EUlJZWlcwTlJQWVU5MFA5Ty4u",
    linkDownload:
      "https://drive.google.com/drive/folders/1eaTXuk2MB7FI-FOlrw_ztRW0C9ndmaah?usp=sharing",
    linkFrame: "https://iseazy.com/dl/edc605889bef4c9fbf671da6290ed9d3",
    upNext: 0,
    metadata: {
      general: {
        title: "Diseño UI/UX",
        language: "Español",
        description: "El contenido del recurso desarrolla elementos esenciales para el diseño de interfaces de usuario, promueve el uso de prácticas de diseño responsivo y fomenta la importancia de los patrones de diseño para este campo.",
        keywords: "Diseño UI/UX, User Interface, Patrones de diseño, Dark Patterns, Layout, Diseño responsivo, Sistemas de diseño",
      },
      lifecycle: {
        version: "1.0",
        author: "Javier Andrés Collazos Gómez",
        entity: "Universidad de Ibagué",
        date: "09/09/09",
      },
      technical: {
        format: "iFrame, .zip",
        size: "250",
        location: "https://javiermojito.github.io/nido/#/cursos/diseno-uiux",
        requirement: `- Tipo: Navegador 
                      - Nombre: Cualquiera`,
        instructions: `Online: acceder a la ruta desde un navegador web.

        Offline: Descomprimir el archivo .zip con su software de preferencia. Ejecutar el archivo con el nombre y simbolo del recurso.`
      },
      educational: {
        interactivityType: "Activo",
        learningResourceType: "Diapositiva",
        interactivityLevel: "Medio",
        targetPopulation: "Aprendiz",
        context: "Educación Secundaria, Educación Superior"
      },
      rights:{
        cost: "No",
        copyright: "Se permite su distribución libre y se prohíbe su uso comercial.",
        otherRestrictions: "Este recurso utiliza material de terceros como objetos de estudio."
      },
      annotation: {
        educationalUse: "Este recurso puede ser utilizado por docentes, estudiantes y cualquier usuario interesado en el diseño UI/UX. Sirve de material complementario para cursos relacionados al desarrollo de aplicaciones y la ingeniería de software.",
      },
      classification:{
        source: `Disciplina:
        - Diseño
        - Ingeniería de software`,
        taxonPath: "TBD"
      }
    },
  },
];

/**
 *  Retorna el objeto con la información de todos los cursos.
 */
export function getCourses() {
  return data;
}

/**
 * Si la ruta que ingresa por parámetro corresponde a la ruta de alguno de los cursos almaneados en data, se retorna el curso.
 * @param {*} path - Ruta del curso
 */
export function getCourseFromPath(path) {
  return data.find((c) => {
    if (c.courseRoute === path) {
      return c;
    }
  });
}

/**
 * Si el id que ingresa por parámetro corresponde al id de alguno de los cursos almaneados en data, se retorna el curso.
 * @param {*} id - ID del curso
 */
export function getCourseFromId(id) {
  return data.find((c) => {
    if (c.id === id) {
      return c;
    }
  });
}

/**
 * Si el id que ingresa por parámetro corresponde al id de alguno de los cursos almacenados en data
 * se obtienen los datos del curso y se interpolan sobre el String que contiene la estructura de metadata IEEE-LOM.
 * @param {*} id - ID del curso
 */
export function getMetadataXMLFromCourseId(id) {
  let course = getCourseFromId(id);
  var xml = `<metadata>
              <schema>LOM</schema>
              <schemaversion>1.0</schemaversion>
              <lom:lom>
                <!-- general -->
                <lom:general>    
                  <lom:title>
                    <lom:langstring xml:lang="es">${course.metadata.general.title}</lom:langstring>
                  </lom:title>
                  <lom:language>${course.metadata.general.language}</lom:language>
                  <lom:description>
                    <lom:langstring xml:lang="es">${course.metadata.general.description}</lom:langstring>
                  </lom:description>
                  <lom:keywords>
                    <lom:langstring xml:lang="es">${course.metadata.general.keywords}</lom:langstring>
                  </lom:keywords>
                </lom:general>
              
                <!-- ciclo de vida -->
                <lom:lifecycle>
                  <lom:version>
                    <lom:langstring xml:lang="es">${course.metadata.lifecycle.version}</lom:langstring>
                  </lom:version>
                  <lom:contribute>
                    <lom:role>        
                      <lom:value>
                        <lom:langstring xml:lang="en">content provider</lom:langstring>
                      </lom:value>
                    </lom:role>
                    <lom:centity>
                      <lom:vcard>
                                  begin:vcard
                                  fn:${course.metadata.lifecycle.author}
                                  end:vcard
                            </lom:vcard>
                    </lom:centity>
                    <lom:date>
                      <lom:datetime>${course.metadata.lifecycle.date}</lom:datetime>
                    </lom:date>
                  </lom:contribute>
                  <lom:entity>
                    <lom:langstring xml:lang="es">${course.metadata.lifecycle.entity}</lom:langstring>
                  </lom:entity>
                </lom:lifecycle>
              
                <!-- Técnico -->
                <lom:technical>
                  <lom:format>${course.metadata.technical.format}</lom:format>
                  <lom:size>${course.metadata.technical.size}</lom:size>
                  <lom:location>${course.metadata.technical.location}</lom:location>
                  <lom:requirement>
                    <lom:type>
                      <lom:value>
                        <lom:langstring xml:lang="es">${course.metadata.technical.requirement}</lom:langstring>
                      </lom:value>
                    </lom:type>
                  </lom:requirement>
                  <lom:installationremarks>
                    <lom:langstring xml:lang="es">${course.metadata.technical.instructions}</lom:langstring>
                  </lom:installationremarks>
                </lom:technical>
              
                <!-- Educacional -->
                <lom:educational>
                  <lom:interactivitytype>
                    <lom:value>
                      <lom:langstring xml:lang="es">${course.metadata.educational.interactivityType}</lom:langstring>
                    </lom:value>
                  </lom:interactivitytype>
                  <lom:learningresourcetype>
                    <lom:value>
                      <lom:langstring xml:lang="es">${course.metadata.educational.learningResourceType}</lom:langstring>
                    </lom:value>
                  </lom:learningresourcetype>
                  <lom:interactivitylevel>
                    <lom:value>
                      <lom:langstring xml:lang="es">${course.metadata.educational.interactivityLevel}</lom:langstring>
                    </lom:value>
                  </lom:interactivitylevel>
                  <lom:intendedenduserrole>
                    <lom:value>
                      <lom:langstring xml:lang="es">${course.metadata.educational.targetPopulation}</lom:langstring>
                    </lom:value>
                  </lom:intendedenduserrole>
                  <lom:context>      
                    <lom:value>
                      <lom:langstring xml:lang="es">${course.metadata.educational.context}</lom:langstring>
                    </lom:value>
                  </lom:context>
                </lom:educational>
              
                <!-- Derechos -->
                <lom:rights>
                  <lom:cost>
                    <lom:value>
                      <lom:langstring xml:lang="es">${course.metadata.rights.cost}</lom:langstring>
                    </lom:value>
                  </lom:cost>
                  <lom:copyrightandotherrestrictions>
                    <lom:value>
                      <lom:langstring xml:lang="es">${course.metadata.rights.copyright}</lom:langstring>
                    </lom:value>
                  </lom:copyrightandotherrestrictions>
                  <lom:description>
                    <lom:langstring xml:lang="es">${course.metadata.rights.otherRestrictions}</lom:langstring>
                  </lom:description>
                </lom:rights>
              
                <!-- Anotaci[on -->
                <lom:annotation>
                  <lom:educationaluse>
                    <lom:value>
                      <lom:langstring xml:lang="es">${course.metadata.annotation.educationalUse}</lom:langstring>
                    </lom:value>
                  </lom:educationaluse>
                </lom:annotation>
              
                <!-- Clasificacion -->
                <lom:classification>
                  <lom:purpose>
                    <lom:value>
                      <lom:langstring xml:lang="es">${course.metadata.classification.source}</lom:langstring>
                    </lom:value>
                  </lom:purpose>
                  <lom:taxonpath>
                    <lom:source>
                      <lom:langstring xml:lang="es">${course.metadata.classification.taxonPath}</lom:langstring>
                    </lom:source>
                    <lom:taxon>
                      <lom:id xml:lang="es">${course.metadata.classification.taxonPath}</lom:id>
                    </lom:taxon>
                  </lom:taxonpath>
                </lom:classification>
              </lom:lom>
            </metadata>`;
  return xml;
}
